<template>  
  <map-fleet ref="map" :uiid="uiid" maptype="fleet" ></map-fleet>
</template>
<script>  
  import MapFleet from '@/components/map/Map'

  export default {
    name: 'FleetMap',    
    components:{MapFleet},    
    props:{
      uiid:{
          type: String,
          required: true,
          default: 'map_global'
      }    
    },
    methods:{
      updateSize() {        
        if(!this.$refs.map) this.$nextTick(this.updateSize)
        else this.$refs.map.updateSize()
      }
    }
  }
</script>
